<template>
	<div class="flex flex-col lg:h-full">
		<div class="flex flex-grow relative">
			<div class="w-full lg:mr-0 main">
				<VehicleModelsForm :models="modelsUnchecked" @delete="deleteModel" @save="saveModels" :is-checkable="true" />

				<BaseInput :label="$t('search')" :filter-only="true" @input="search($event)" :sublabel="$t('min_two_chars')" v-model="searchValue" />
				<div v-if="modelsAll">
					<BaseTable
						:heads="heads"
						:rows="modelsAll"
						v-if="modelsAll.length"
						:mapping="mapping"
						:enable-search="false"
						:row-main-function="editModel"
					/>
					<div v-else>
						{{ $t('no_model_found') }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VehicleModelsForm from '@/views/vehicles/VehicleModelsForm';
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseTable from '@/components/forms/BaseTable';
import BaseInput from '@/components/forms/inputs/BaseInput';
import VehicleModelRepository from '@/api/repositories/VehicleModelRepository';

export default {
	name: 'VehiclesModels',
	components: { BaseInput, BaseTable, VehicleModelsForm },
	data() {
		return {
			searchTimeoutId: null,
			searchValue: null,
			modelsAll: null,
			modelsUnchecked: null,
			heads: [
				{ title: this.$t('wmi'), key: 'wmi' },
				{ title: this.$t('vds'), key: 'vds' },
				{ title: this.$t('name'), key: 'name' },
			],
		};
	},
	mounted() {
		VehicleModelRepository.index({ uncheck: true }).then(response => {
			this.modelsUnchecked = response.data.data;
		});

		if (this.$route.query.searchValue) {
			this.searchValue = this.$route.query.searchValue;
			this.search();
		}
	},
	computed: {
		isModelsTypeAll() {
			return this.$route.name === 'vehicles.models';
		},
	},
	methods: {
		search(value) {
			clearTimeout(this.searchTimeoutId);
			this.searchTimeoutId = setTimeout(() => {
				if (this.searchValue.length > 1) {
					VehicleModelRepository.index({ searchValue: this.searchValue }).then(response => {
						this.modelsAll = response.data.data;
						this.$router.replace({ name: this.$route.name, query: { searchValue: this.searchValue } });
					});
				} else {
					this.modelsAll = null;
					this.$router.replace({ name: this.$route.name, query: { searchValue: null } });
				}
			}, 300);
		},
		editModel(row) {
			this.$router.push({ name: 'vehicles.model.id', params: { id: row.id } });
		},
		mapping(row) {
			return {
				id: row['id'],
				wmi: row['wmi'],
				vds: row['vds'],
				name: row['name'],
			};
		},
		loadModels() {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesModelsGet()
				.then(response => {
					this.modelsAll = response.data.all;
					this.modelsUnchecked = response.data.unchecked;
				});
		},
		saveModels(models) {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesModelsPut(models)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.loadModels();
					this.$swal(this.$t('general.success').toString(), this.$t('models_saved').toString(), 'success');
					this.$router.push({ name: 'vehicles.overview' });
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('models_save_error').toString(), 'error');
				});
		},
		deleteModel(modelId) {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesModelsIdDelete(modelId)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('model_deleted').toString(), 'success');
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('model_delete_error').toString(), 'error');
				});
		},
	},
};
</script>

<style scoped>
.main {
	height: 100vh;
}
</style>
